<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default{
    name: "table-evaluasi-seminar-implementasi",

    data(){

        return{
            id: this.$route.params.id,
            templateExcel: '/template_excel/template_seminar_implementasi.xlsx',
            showModal : false,
            pathExcel:false,
            loadingTable:true,
            nilaiImplementasi: null,
            dataTableSeminarImplementasi: [],
        }
    },
    mounted(){
        this.getDataTableEvaluasiSeminarImplementasi(this.id);
    },
    methods:{
    getDataTableEvaluasiSeminarImplementasi(id) {
      let self = this;
      self.loadingTable = true;

      // get data table evaluasi stula
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/evaluasi-seminar-implementasi",
        params: {
          id: id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config)
        .then(function (response) {
          self.loadingTable = false;

          var response_data = response.data;
          var response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            self.dataTableSeminarImplementasi = response_data_fix;
          } else {
            self.dataTableSeminarImplementasi = [];
          }
        })
        .catch(function (error) {
          self.loadingTable = false;
          self.dataTableSeminarImplementasi = [];
          console.log(error);
        });
    },
    importEvaluasiSeminarImplementasi() {
      let self = this;
      self.showModal = true;
    },
    inputFileExcelSeminarImplementasi() {
      let self = this;
      if ($("#inputExcelEvaluasiSeminarImplementasi")[0].files[0]) {

        let fileName = $("#inputExcelEvaluasiSeminarImplementasi")[0].files[0].name;
        let fileExtension = fileName.split('.').pop().toLowerCase();

        if (fileExtension === 'xlsx') {
          $("#uploadLoadingSeminarImplementasi").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#inputExcelEvaluasiSeminarImplementasi")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            var resStatus = response.status;
            if (resStatus === 200) {
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingSeminarImplementasi").html(
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-check"></i>' +
                'Berhasil' +
                '</span>' +
                '<a href="' + urlres + '" target="_blank" style="padding-left:10px;">' +
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-eye"></i>' +
                'Lihat File' +
                '</span>' +
                '</a>'
              );

              self.pathExcel = path_file;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong !',
                showConfirmButton: true,
              });
            }
          });
        } else {
          alert("Format file harus ber-type (XLSX)");
          $('#inputExcelEvaluasiSeminarImplementasi').val('');
        }
      }
    },
    exportEvaluasiSeminarImplementasi() {
      let self = this;

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/eksportEvaluasi/seminar-implementasi',
        params: {
          id: self.id,
        },
        crossdomain: true,
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        withCredentials: true,
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.close();
          // Download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Evaluasi Nilai Seminar Implementasi.xlsx'); // Update filename if needed
          document.body.appendChild(link);
          link.click();
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n' + error,
          showConfirmButton: true
        });
      });
    },
    storeImportEvaluasiSeminarImplementasi() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/importEvaluasi/seminarImplementasi",
        data: {
          id: self.id,
          path_excel: self.pathExcel
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Success upload data !',
            showConfirmButton: true,
          });

          $("#inputExcelEvaluasiSeminarImplementasi").val('');
          $("#uploadLoadingSeminarImplementasi").empty();
          self.showModal = false;

          self.getDataTableEvaluasiSeminarImplementasi(self.id);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong !',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n ' + error,
          showConfirmButton: true,
        });
      });
    },
    mathSeminarImplementasi(row_data) {
      const aspekim1 = parseFloat(row_data.aspekim1) || 0;
      const aspekim2 = parseFloat(row_data.aspekim2) || 0;
      const aspekim3 = parseFloat(row_data.aspekim3) || 0;
      const aspekim4 = parseFloat(row_data.aspekim4) || 0;
      const aspekim5 = parseFloat(row_data.aspekim5) || 0;
      const aspekim6 = parseFloat(row_data.aspekim6) || 0;
      const aspekim7 = parseFloat(row_data.aspekim7) || 0;

      row_data.nilaiImplementasi = ((aspekim1 * 0.05) + (aspekim2 * 0.05) + (aspekim3 * 0.06) + (aspekim4 * 0.03) + (aspekim5 * 0.05) + (aspekim6 * 0.03) + (aspekim7 * 0.03)) * 0.3;
      row_data.nilaiImplementasi = row_data.nilaiImplementasi.toFixed(2);
    },
    }
}
</script>
<template>
    <div class="row">
        <div class="col-md-12">
        <div class="card-title mt-3">Evaluasi Seminar Implementasi</div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12 text-end">
        <b-button variant="info" size="sm" @click="importEvaluasiSeminarImplementasi()">
            <i class="fas fa-upload"></i>
            &nbsp;
            <b>Import Evaluasi Implementasi</b>
        </b-button>
        &nbsp;
        <b-button variant="info" size="sm" @click="exportEvaluasiSeminarImplementasi()">
            <i class="fas fa-file-excel"></i>
            &nbsp;
            <b>Export Evaluasi Implementasi</b>
        </b-button>
        </div>
    </div>

    <div class="col-md-12 table-responsive pb-3">
        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
        <thead class="purpleTheme align-middle">
            <tr>
            <th class="text-center" rowspan="3">NDH</th>
            <th class="text-center" rowspan="3">Nama Peserta</th>
            <th class="text-center" colspan="14">Indikator</th>
            <th class="text-center" rowspan="2">Jumlah Nilai</th>
            </tr>
            <tr>
            <th class="text-center" colspan="2">Capaian Hasil<br>Perubahan<br>Terhadap Rencana Perubahan</th>
            <th class="text-center" colspan="2">Kepemimpinan<br>Pelayanan</th>
            <th class="text-center" colspan="2">Kemanfaatan <br>Aksi <br>Perubahan</th>
            <th class="text-center" colspan="2">Keberlanjutan <br>Aksi <br>Perubahan</th>
            <th class="text-center" colspan="2">Pelaksanaan Strategi <br>Pengembangan Kompetensi <br>dalam <br>Aksi Perubahan</th>
            <th class="text-center" colspan="2">Keterkaitan <br>Mata Pelatihan<br> Pilihan dengan <br>Aksi Perubahan</th>
            <th class="text-center" colspan="2">Keberlanjutan <br>Aksi Perubahan</th>
            </tr>
            <tr>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">5%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">5%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">6%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">3%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">5%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">3%</th>
            <th class="text-center" style="min-width: 100px;">&nbsp;</th>
            <th class="text-center">3%</th>
            <th class="text-center">30%</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="loadingTable == true">
            <td colspan="30">
                <i class="fas fa-spin fa-spinner"></i>
                &nbsp;
                <span>loading . . .</span>
            </td>
            </tr>
            <tr v-else-if="dataTableSeminarImplementasi == ''">
            <td colspan="30" class="text-center">
                -- Data Kosong --
            </td>
            </tr>
            <tr v-else v-for="(row_data2, key_data2) in dataTableSeminarImplementasi" :key="key_data2" class="align-middle">
            <td class="text-center">{{ key_data2 + 1 }}</td>
            <td>{{ row_data2.user.name }}</td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim1 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim1 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim2 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim2 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim3 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim3 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim4 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim4 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim5 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim5 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim6 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim6 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.aspekim7 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.percent_aspekim1 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data2.user.name">
                {{ row_data2.nilai_implementasi }}
                </span>
            </td>
            </tr>
        </tbody>
        </table>
    </div>

    <b-modal v-model="showModal" title="Import Evaluasi Seminar Implementasi" title-class="text-black font-18" body-class="p-3" hide-footer>
    <form @submit.prevent="storeImportEvaluasiSeminarImplementasi()">
      <div class="row mt-2">
        <div class="col-12 text-end">
          <a :href="templateExcel" target="_blank" class="btn btn-sm btn-success" style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
            <i class="fas fa-download"></i>
            &nbsp;
            <span><b>Download Template</b></span>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input type="file" class="form-control" id="inputExcelEvaluasiSeminarImplementasi" placeholder="Masukkan File Excel . . ." v-on:change="inputFileExcelSeminarImplementasi()" accept=".xlsx" style="border-top-right-radius: 0px !important;">
        </div>
        <div class="col-12">
          <div class="respond-input-file float-left" id="uploadLoadingSeminarImplementasi"></div>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <b-button variant="primary" type="submit">
            <i class="fas fa-check"></i>
            &nbsp;
            <span><b>Simpan</b></span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>

</template>